<template>
   <div class="page bg-gray pb-fixed-btn">
       <backTitleBar></backTitleBar>
       <div class="content">
           <div class="card">
               <div class="pd-020">
                   <div class="input-field bd-bot">
                       <div class="fs-32 color-333 left required">营业执照<br/>单位名称</div>
                       <van-field @click="inputClick()" class="input" type="text" :clearable="true" v-model="formItem.licenseName" placeholder="请输入营业执照单位名称" />
                   </div>
                   <div class="input-field bd-bot">
                       <div class="fs-32 color-333 left required">营业执照号</div>
                       <van-field @click="inputClick()"  class="input" type="text" :clearable="true" v-model="formItem.licenseNo" placeholder="请输入营业执照号" />
                   </div>
                   <div class="input-field bd-bot">
                       <div class="fs-32 color-333 left required">法人姓名</div>
                       <van-field @click="inputClick()" class="input" type="text" :clearable="true" v-model="formItem.identityName" placeholder="请输入法人姓名" />
                   </div>
                   <div class="input-field bd-bot">
                       <div class="fs-32 color-333 left required">法人<br/>身份证号</div>
                       <van-field @click="inputClick()" class="input" type="text" :clearable="true" v-model="formItem.identityCard" placeholder="请输入法人身份证号" />
                   </div>
                   <div class="input-field bd-bot">
                       <div class="fs-32 color-333 left required">注册地址</div>
                       <van-field @click="inputClick()" class="input" type="text" :clearable="true" v-model="formItem.regAddress" placeholder="请输入注册地址" />
                   </div>
                   <div class="filed-input-box bd-bot">
                       <div class="required fs-32 color-333">上传清晰营业执照</div>
                       <div class="fs-28 color-999 pl-15">(支持jpg、bmp格式图片，大小不要超过1M/张)</div>
                       <div class="flex" style="flex-wrap: wrap;">
                           <div class="pic-box" v-show="formItem.licensePicView">
                               <img :src="formItem.licensePicView" alt="" >
                               <div class="clean" @click="delImg('licensePicView')"></div>
                           </div>
                           <van-uploader v-model="imgList" preview-size="1.45rem" :preview-image="false" :after-read="afterReadLicense" v-show="!formItem.licensePicView"/>
                       </div>
                   </div>
                   <div class="filed-input-box bd-bot">
                       <div class=" fs-32 color-333">上传其他清晰证件</div>
                       <div class="fs-28 color-999 pl-15">(支持jpg、bmp格式图片，大小不要超过1M/张)</div>
                       <div class="flex" style="flex-wrap: wrap;">
                           <div class="pic-box" v-show="formItem.otherPicView">
                               <img :src="formItem.otherPicView" alt="" >
                               <div class="clean" @click="delImg('otherPicView')"></div>
                           </div>
                           <van-uploader v-model="imgList" preview-size="1.45rem" :preview-image="false" :after-read="afterReadOther" v-show="!formItem.otherPicView"/>
                       </div>
                   </div>
               </div>
           </div>
       </div>
       <div class="fixed-bot">
           <div class="btn click" @click="submitForm()">保存</div>
       </div>
   </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qryShopDetail,saveMallShopInfo} from "@/api/shop"
    import uploadImg from "@/api/uploadImg"
    import inputFix from "@/mixins/inputBugFix"
    export default {
        name: "qualifyInfo",
        components:{backTitleBar},
        mixins:[inputFix],
        data(){
            return{
                formItem:{},
                imgList:[],
                shopId:this.$store.state.user.shopId,
            }
        },
        created(){
            this.getDetail();
        },
        methods:{
            inputClick(){
                window.setTimeout(function() {
                  document.activeElement.scrollIntoView({block:"center"})
                }, 200);
            },
            //删除图片
            delImg(field){
                this.$set(this.formItem,field,'')
            },
            //选中图片后上传服务器
            async afterReadLicense(file){
                let result = await uploadImg(file.file,'shop');
                this.setField(result,'licensePic','licensePicView')
            },
            async afterReadOther(file){
                console.log("读取文件成功：",file)
                let result = await uploadImg(file.file,'shop');
                this.setField(result,'otherPic','otherPicView')
            },
            setField(result,picField,picViewField){
                this.$set(this.formItem,picField,result.fileUrl)
                this.$set(this.formItem,picViewField,result.fileUrlView)
            },

            //获取商家详情
            getDetail(){
                qryShopDetail(this.shopId).then(res=>{
                    this.formItem = res.data;
                })
            },

            submitForm(){
                let form = this.formItem
                if(!form.licenseName || !form.licenseNo || !form.identityName || !form.identityCard || !form.regAddress){
                    this.$toast("请填写必填项目");
                    return
                }
                if(!form.licensePicView){
                    this.$toast("请上传营业执照");
                    return
                }
                let params = {
                    licenseName: form.licenseName,
                    licenseNo: form.licenseNo,
                    identityName: form.identityName,
                    identityCard: form.identityCard,
                    regAddress: form.regAddress,
                    licensePic: form.licensePic,
                    shopName: form.shopName,
                    shopId:form.shopId
                }
                if(form.otherPic){
                    params.otherPic = form.otherPic
                }
                saveMallShopInfo(params).then(res=>{
                    if(res.code == 0){
                        this.$toast("保存成功");
                        this.$router.back();
                    }

                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .content{
        padding: .2rem .24rem;
    }
</style>



// WEBPACK FOOTER //
// qualifyInfo.vue?55940268